var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibasbadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.038,
    height: 13.428,
    viewBox: "0 0 12.038 13.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(-201 -117.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(205.565 120.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M280.808,278.555v.215h-3.79v-5.651H278.2v5.436Z",
    transform: "translate(-277.018 -273.119)",
    fill: "#c49235"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M285.324,320.644l.186.186-1.418,1.419-.189-.191Z",
    transform: "translate(-283.007 -314.451)",
    fill: "#c49235"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(201 117.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M6.6,2.46q-1.228.33-2.439.718a.407.407,0,0,0-.282.328,9.946,9.946,0,0,0,1.937,7.711A9.122,9.122,0,0,0,7.785,13.09a5.374,5.374,0,0,0,.767.448,1.94,1.94,0,0,0,.252.1.654.654,0,0,0,.087.022.514.514,0,0,0,.087-.021,2.105,2.105,0,0,0,.252-.1A5.352,5.352,0,0,0,10,13.09a9.129,9.129,0,0,0,1.967-1.874A9.943,9.943,0,0,0,13.9,3.506a.407.407,0,0,0-.282-.328C13.059,3,12.114,2.707,11.18,2.46a11.5,11.5,0,0,0-2.289-.44A11.491,11.491,0,0,0,6.6,2.46ZM6.373,1.6a11.983,11.983,0,0,1,2.518-.47,12.013,12.013,0,0,1,2.518.47q1.249.335,2.482.73a1.3,1.3,0,0,1,.9,1.06,10.845,10.845,0,0,1-2.119,8.384A10.019,10.019,0,0,1,10.5,13.827a6.215,6.215,0,0,1-.9.525,1.86,1.86,0,0,1-.713.2,1.86,1.86,0,0,1-.713-.2,6.184,6.184,0,0,1-.9-.525,10.019,10.019,0,0,1-2.164-2.059,10.841,10.841,0,0,1-2.12-8.384,1.3,1.3,0,0,1,.9-1.06q1.232-.394,2.482-.73Z",
    transform: "translate(-2.872 -1.125)",
    fill: "#c49235",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibasbadge);
export default __webpack_public_path__ + "static/media/libasbadge.c8422a31f0825afaf242ff111c9680f9.svg";
export { ForwardRef as ReactComponent };